import { useCallback, useState } from 'react'
import { cleanEmailInput, HIDDEN_CHAR_NOTICE } from '../auth/normalizeEmail'

/*
 * Email-field cleaning (boardroom-365 Tier B, 2026-10-31): every email input
 * removes hidden spaces and invisible characters as they arrive (paste,
 * predictive text) and says so, so the address the person sees is the one we
 * send. See src/auth/normalizeEmail.ts.
 */

/** useState for an email field: the setter cleans, and `hidden` turns true
 *  once anything was removed (until the field is emptied). */
export function useCleanEmail(initial: string | (() => string) = '') {
  const [state, setState] = useState(() => {
    const raw = typeof initial === 'function' ? initial() : initial
    const c = cleanEmailInput(raw)
    return { email: c.value, hidden: c.changed }
  })
  const setEmail = useCallback((raw: string) => {
    const c = cleanEmailInput(raw)
    setState((prev) => ({ email: c.value, hidden: c.value === '' ? false : prev.hidden || c.changed }))
  }, [])
  return [state.email, setEmail, state.hidden] as const
}

/** The notice line under a cleaned email field. */
export function EmailHiddenCharNotice({ show, testid = 'email-hidden-char-notice' }: { show: boolean; testid?: string }) {
  if (!show) return null
  return (
    <p data-testid={testid} role="status" style={{ margin: '4px 0 0', fontSize: 12, lineHeight: 1.45, color: 'var(--text-muted, var(--tru-text-tertiary))' }}>
      {HIDDEN_CHAR_NOTICE}
    </p>
  )
}
